import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Flex, Spinner, Text, Button } from '@chakra-ui/react';
import { useAuth } from 'lib/auth';

/** /handoff?code=... — mở từ app (nút "Mở Portal"): đổi mã lấy phiên rồi vào /admin. */
export default function Handoff() {
  const [params] = useSearchParams();
  const { loginHandoff } = useAuth();
  const navigate = useNavigate();
  const [err, setErr] = useState('');
  const ran = useRef(false); // tránh chạy 2 lần (mã handoff dùng 1 lần)

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const code = params.get('code');
    if (!code) { setErr('Thiếu mã đăng nhập nhanh.'); return; }
    loginHandoff(code)
      .then(() => navigate('/admin', { replace: true }))
      .catch((e) => setErr(e.message || 'Đăng nhập nhanh thất bại'));
  }, [params, loginHandoff, navigate]);

  return (
    <Flex minH="100vh" align="center" justify="center" direction="column" gap="16px" p="24px">
      {err ? (
        <>
          <Text fontSize="lg" fontWeight="700">⚠️ {err}</Text>
          <Button colorScheme="brand" onClick={() => navigate('/auth/sign-in', { replace: true })}>
            Về trang đăng nhập
          </Button>
        </>
      ) : (
        <>
          <Spinner size="xl" thickness="4px" color="brand.500" />
          <Text color="secondaryGray.600">Đang đăng nhập nhanh…</Text>
        </>
      )}
    </Flex>
  );
}
